import { useRootTypeContext } from "@/pages/configurations/rootTypes/context/RootTypeContext";
import {
	cellActionsStyle,
	rowButtonStyle,
	rowIconButtonStyle,
} from "@/utils/ag-grid-defaults";
import { Button, Grid } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import { ColDef } from "ag-grid-community";
import { find } from "lodash-es";
import { useComponentTypesContext } from "../../../context/ComponentTypeContext";

type Props = {
	setModalEditComponent: Function;
	setModalDeleteComponent: Function;
	setComponentIdForEdit: Function;
	setComponentIdForDelete: Function;
	setModalPart: Function;
};
export const useTableData = ({
	setComponentIdForEdit,
	setModalEditComponent,
	setComponentIdForDelete,
	setModalDeleteComponent,
	setModalPart,
}: Props) => {
	const {
		state: { componentTypes },
	} = useComponentTypesContext();
	const {
		state: { rootTypes },
	} = useRootTypeContext();

	const columns: ColDef[] = [
		{
			field: "componentTypeId",
			headerName: "#",
			width: 70,
		},
		{
			field: "componentTypeName",
			headerName: "Name",
			flex: 1,
		},
		{
			field: "rootTypeId",
			headerName: "Root Type",
			flex: 1,
			filter: "agSetColumnFilter",
		},
		{
			field: "isRepair",
			headerName: "Is Repair",
			flex: 1,
		},
		{
			field: "isTracked",
			headerName: "Is Tracked",
			flex: 1,
		},
		{
			field: "parts",
			headerName: "Parts",
			flex: 1,
			cellRenderer: (params: any) => {
				return (
					<span style={cellActionsStyle}>
						{params.data.isRepair !== "Yes" && (
							<Button
								variant="outlined"
								color="primary"
								size="small"
								style={rowButtonStyle}
								onClick={() => {
									(async () => {
										setComponentIdForEdit(params.data.componentTypeId);
										setModalPart(true);
									})();
								}}
							>
								Parts
							</Button>
						)}
					</span>
				);
			},
		},
		{
			field: "Actions",
			cellRenderer: (params: any) => {
				return (
					<span style={cellActionsStyle}>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setComponentIdForEdit(params.data.componentTypeId);
								setModalEditComponent(true);
							}}
						>
							<EditIcon style={{ width: 18, height: 18 }} color="primary" />
						</Button>
						<Button
							size="small"
							style={rowIconButtonStyle}
							onClick={() => {
								setComponentIdForDelete(params.data.componentTypeId);
								setModalDeleteComponent(true);
							}}
						>
							<DeleteIcon style={{ width: 18, height: 18 }} color="secondary" />
						</Button>
					</span>
				);
			},
			headerName: " ",
			sortable: false,
			maxWidth: 100,
		},
	];

	const rows = componentTypes.map(
		({
			componentTypeId,
			componentTypeName,
			rootTypeId,
			isRepair,
			isTracked,
		}) => {
			const rootType = find(rootTypes, ["rootTypeId", rootTypeId]);

			return {
				componentTypeId,
				componentTypeName,
				rootTypeId: rootType?.rootTypeName,
				isRepair: isRepair ? "Yes" : "No",
				isTracked: isTracked ? "Yes" : "No",
				id: componentTypeId,
			};
		},
	);

	return { rows, columns };
};
